import type { RootState } from '../store';
import { Setting } from '../common/types/settings';

const getAdvisors = (state: RootState): Setting[] => state.settings.advisors;

const getGroups = (state: RootState): Setting[] => state.settings.groups;

const getStatus = (state: RootState) => state.settings.status;

const settingsSelectors = {
  getAdvisors,
  getGroups,
  getStatus,
};

export default settingsSelectors;
